export class AddExternalJobDto {
    title: string;
    matchedLeadsProductId: string;
}